'use client';

import { Bounce, Fade, Slide } from 'react-awesome-reveal';

import { InlineStyles } from '@web/types';

type RevealType = 'bounce' | 'fade' | 'slide'; // * We can add more types here if needed.

type RevealProps = {
  type?: RevealType;
  children: React.ReactNode;
  duration?: number;
  direction?: 'left' | 'right' | 'up' | 'down';
  delay?: number;
  triggerOnce?: boolean;
  style?: InlineStyles;
};

export function Reveal({
  type = 'slide',
  children,
  duration = 600,
  direction = 'right',
  delay = 0,
  triggerOnce = true,
  style = {},
}: RevealProps) {
  const props = { duration, delay, triggerOnce, direction, style };

  const Animation =
    type === 'bounce' ? Bounce : type === 'slide' ? Slide : Fade;

  return (
    <Animation
      {...props}
      style={{
        ...style,
      }}
    >
      {children}
    </Animation>
  );
}
